import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const initializeSwiperSingleUnidade = () => {
  const unidadeSection = document.getElementById("conteudo-sigle-unidade");
  if (!unidadeSection) return;

  const swiper = new Swiper(".mySwiperUnidade", {
    slidesPerView: 1,
    spaceBetween: 24,
    loop: true,
    navigation: {
      nextEl: ".swiper-single-unidade-next",
      prevEl: ".swiper-single-unidade-prev",
    },
    pagination: {
      el: ".swiper-single-unidade-pagination",
      clickable: true,
    },
  });
};

export default initializeSwiperSingleUnidade;
